import { LegalDocument } from '../../components/legal/LegalDocument';
import { termsAppContent } from '../../content/legal/termsAppContent';

export function AppTerms() {
  return (
    <LegalDocument
      content={termsAppContent}
      platform="app"
      seoDescription="LuvLust Terms and Conditions. One-time in-app purchase terms for the couples app on iOS and Android."
      seoKeywords="luvlust terms, in-app purchase terms, app store terms, couples app terms"
    />
  );
}
